import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChannelCategory } from 'icreate/common/models/channel-category';
import { DutyEngineerView } from 'icreate/common/models/duty-engineer';
import { DutyEngineerCategoryService } from '@service/duty-engineer-category.service';

export type CategoryAssignment = {
    [engineerId: string]: { [categoryId: string]: boolean };
};

@Component({
    selector: 'app-edit-categories-dialog',
    templateUrl: './edit-categories-dialog.component.html',
    styleUrls: ['./edit-categories-dialog.component.css'],
    standalone: false,
})
export class EditCategoriesDialogComponent implements OnInit {
    assignments: CategoryAssignment = {};
    readonly pageSize = 4;

    isLoading = false;
    isModified = false;
    currentPage = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            engineerList: DutyEngineerView[];
            channelCategories: ChannelCategory[];
            vesselId: string;
        },
        private dialogRef: MatDialogRef<EditCategoriesDialogComponent>,
        private dutyEngineerCategoryService: DutyEngineerCategoryService
    ) {
        for (const engineer of data.engineerList) {
            this.assignments[engineer.id] = {};
            for (const category of data.channelCategories) {
                this.assignments[engineer.id][category.id] = false;
            }
        }
    }

    async ngOnInit() {
        this.isLoading = true;
        try {
            const records = await this.dutyEngineerCategoryService.getListByVesselId(this.data.vesselId);
            for (const record of records) {
                if (
                    this.assignments[record.dutyEngineerId] &&
                    this.assignments[record.dutyEngineerId][record.categoryId] !== undefined
                ) {
                    this.assignments[record.dutyEngineerId][record.categoryId] = true;
                }
            }
        } catch (error) {
            console.error(error);
        }
        this.isLoading = false;
    }

    get pagedCategories(): (ChannelCategory | null)[] {
        const start = this.currentPage * this.pageSize;
        const pageItems = this.data.channelCategories.slice(start, start + this.pageSize);
        const emptySlots = this.pageSize - pageItems.length;
        return [...pageItems, ...Array(emptySlots).fill(null)];
    }

    get categoryRangeLabel(): string {
        const start = this.currentPage * this.pageSize + 1;
        const end = Math.min((this.currentPage + 1) * this.pageSize, this.data.channelCategories.length);
        return `${start}-${end}`;
    }

    prevPage() {
        if (this.currentPage > 0) this.currentPage--;
    }

    nextPage() {
        if ((this.currentPage + 1) * this.pageSize < this.data.channelCategories.length) {
            this.currentPage++;
        }
    }

    markAsModified() {
        this.isModified = true;
    }

    cancelClick() {
        this.dialogRef.close(null);
    }

    saveClick() {
        this.dialogRef.close(this.assignments);
    }
}
